import { render } from "./Dashboard_default.vue?vue&type=template&id=1956f63e"
import script from "./Dashboard_default.vue?vue&type=script&lang=js"
export * from "./Dashboard_default.vue?vue&type=script&lang=js"

import "./Dashboard_default.vue?vue&type=style&index=0&id=1956f63e&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__